import { render, staticRenderFns } from "./SectionColumn.vue?vue&type=template&id=ebb67bc0"
import script from "./SectionColumn.vue?vue&type=script&lang=ts"
export * from "./SectionColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports